module.exports = __webpack_public_path__ + "static/wireframing-mobile-13f9065e106336e936abbb7efa450bdf.jpg";